export const lightTheme = {
  body: "#e2e2e2",
  text: "#363537",
  toggleBorder: "#fff",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  font: "utopia_seriff"
};

export const darkTheme = {
  body: "#363537",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#091236, #1E215D)",
  font: "utopia_seriff"
};
